import React, { useEffect, useState } from 'react';
import { Registration } from './funnel/Registration';
import { Qualify } from './funnel/Qualify';
import { ThankYou, Confirmed } from './funnel/ThankYou';
import { Privacy, Terms } from './funnel/Legal';
import { initPixel, track } from './funnel/pixel';
import { protect } from './utils/protect';
import { applySeo } from './utils/seo';

// Ruteo por hash:
// #/            Paso 1: registro (nombre, email, WhatsApp)
// #/aplicar     Paso 2: preguntas de filtro, una por pantalla
// #/agenda      Video explicativo + calendario GHL
// #/confirmada  Redirección post-reserva desde GHL
// #/privacidad  Política de Privacidad
// #/terminos    Términos y Condiciones
function getRoute() {
  // Se ignora el query (?utm_...=) para que la ruta siga siendo la correcta
  return window.location.hash.replace(/^#/, '').split('?')[0] || '/';
}
export function App() {
  const [route, setRoute] = useState(getRoute());
  useEffect(() => {
    initPixel();
    track('PageView');
    const h = () => {
      setRoute(getRoute());
      window.scrollTo(0, 0);
      track('PageView');
    };
    window.addEventListener('hashchange', h);
    return () => window.removeEventListener('hashchange', h);
  }, []);

  // Capa anti-copia (una sola vez)
  useEffect(() => protect(), []);

  // SEO: título, robots y canonical en cada cambio de ruta
  useEffect(() => {
    applySeo(route);
  }, [route]);
  const go = (r: string) => {
    window.location.hash = r;
  };
  return <div className="min-h-full w-full bg-white" data-id="element-0" data-mp="2zn678kkz7rhf">
      {route === '/aplicar' ? <Qualify onDone={() => go('/agenda')} data-id="element-1" data-mp="33n6y54p9hv5d" /> : route === '/agenda' ? <ThankYou data-id="element-2" data-mp="38li6tc3tlzm0" /> : route === '/confirmada' ? <Confirmed data-id="element-3" data-mp="38nupjrheke04" /> : route === '/privacidad' ? <Privacy data-id="element-4" data-mp="3dl4kfmnk9hvc" /> : route === '/terminos' ? <Terms data-id="element-5" data-mp="3diruam7ng177" /> : <Registration onSuccess={() => go('/aplicar')} data-id="element-6" data-mp="nvj53kddcmru" />}
    </div>;
}